module.exports = __webpack_public_path__ + "static/media/mdi_plus-circle.63c4303f.svg";